import {BASE_URL, GAME_ZONE_URL} from "modules/constants";

export const getUri = (page: string, redirectUri: string) =>
	redirectUri ? `${GAME_ZONE_URL}${page}?redirectUri=${BASE_URL}${redirectUri}` : `login`;
